import React from 'react';

import Link from 'components/Link';
import Icon from 'components/Icon';
import Segment from 'components/Segment';
import FullWidth from 'layouts/FullWidth';

import './register.css';

const RegisterSuccess = () => {
  return (
    <FullWidth id="register" className="full-height">
      <FullWidth.Content className="bg-color-white">
        <div id="left" className="bg-color-white bg-lighten1">
          <Link to="/" className="psycho_logo">
            <Icon name="logo" color="aqua" />
            <Icon name="logo_text" />
          </Link>
          <Segment id="form">
            <h4>Verify your email</h4>
            <p>
              Confirm your email by clicking the verification link we sent to your inbox and start
              learning.
            </p>
          </Segment>
        </div>
        <div id="right" />
      </FullWidth.Content>
    </FullWidth>
  );
};

export default RegisterSuccess;
